import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';

export default function Controls_ScheduleManagement_Timetable_Selector({ children, onRoomSelect, onToggle }) {
    const UI = useContext(Context_UI);
    const [ShowAll, ShowAll_Set] = useState(true);

    useEffect(() => {
        const OnButtonToggle = ({ ID, State }) => {
            if (ID === "Controls_Timetable_Specifity") {
                const isActive = State === "Active";
                ShowAll_Set(isActive);
                if (onRoomSelect) onRoomSelect(isActive ? null : null);
            }
        };

        UI.on("Button_Toggled", OnButtonToggle);
        return () => {
            UI.off("Button_Toggled", OnButtonToggle);
        };
    }, [onRoomSelect]);

    useEffect(() => {
        if (ShowAll && onRoomSelect) onRoomSelect(null);
    }, [ShowAll]);

    const handleRoomSelect = (roomId) => {
        if (!ShowAll && onRoomSelect) {
            onRoomSelect(roomId);
        }
    };

    const handleClick = (State) => {
        if (onToggle) {
            onToggle(State);
        }
    }

    return (
        <div className="Controls_Timetable_Selector">
            <UI_LinearGroup Direction="Row" Gap="Gap" Wrap={true}>
                <UI_Toggle
                    id="Controls_Timetable_Specifity"
                    Text="View all schedules"
                    Selected={ShowAll ? "true" : "false"}
                    onClick={(State) => handleClick(State)}
                />

                {children}
            </UI_LinearGroup>
            {!ShowAll && (
                <Controls_Map_Selector
                    Room_Show={true}
                    Room_Selectable={true}
                    NoTime={true}
                    Labels={false}
                    Form={false}
                    Absolute={false}
                    onRoomSelect={handleRoomSelect}
                />
            )}
        </div>
    );
}
